export var YonderlandMediatorAction;
(function (YonderlandMediatorAction) {
    YonderlandMediatorAction["PUBLISH"] = "publish";
    YonderlandMediatorAction["SUBSCRIBE"] = "subscribe";
    YonderlandMediatorAction["UNSUBSCRIBE"] = "unsubscribe";
})(YonderlandMediatorAction || (YonderlandMediatorAction = {}));
export var YonderlandMediatorGroup;
(function (YonderlandMediatorGroup) {
    YonderlandMediatorGroup["BASKET"] = "basket";
})(YonderlandMediatorGroup || (YonderlandMediatorGroup = {}));
